module.exports = "<div class=\"tools-inner\">\n    <div *ngIf=\"caption\" class=\"caption\">\n        <span *ngIf=\"iconTitle\"\n              class=\"action\" translate\n              (click)=\"iconAction()\">{{ iconTitle }}</span>\n        <h2 translate>{{ caption }}</h2>\n        <ui-label *ngIf=\"captionLabel\">{{ captionLabel }}</ui-label>\n    </div>\n    <div class=\"tools\">\n        <ng-content></ng-content>\n    </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/utils/ui-elements/ui-header/ui-header.html
// module id = 1114
// module chunks = 3